import { GuestProfile } from "@closerplatform/spinner-openapi";
import {
  AsyncAutoComplete,
  AsyncAutoCompleteState
} from "@fidget/common/components/form/asyncAutoComplete/asyncAutoComplete";
import { SpinIcon } from "@fidget/common/components/icons/spinIcon/spinIcon";
import { intl } from "@fidget/common/i18n/TypedIntl";
import classNames from "classnames";
import { ControllerStateAndHelpers } from "downshift";
import React from "react";
import { useAgentServices } from "../../models/agentServices";
import { GuestDropdownItemGuestProfile } from "../guestDropdown/guestDropdownItem";
import styles from "./navbarSearch.css";

interface Props {
  searchResultPicked: (profile: GuestProfile) => void;
}

export const NavbarSearch = ({ searchResultPicked }: Props) => {
  const { spinnerService } = useAgentServices();

  const onItemSelect = (profile: GuestProfile, helpers: ControllerStateAndHelpers<GuestProfile>) => {
    searchResultPicked(profile);
    // reset selection in Downshift to be able to trigger the selected item change
    // event on the same item again without reloading the query results
    helpers.setState({ selectedItem: undefined });
  };

  const renderQueryInput = (
    helpers: ControllerStateAndHelpers<GuestProfile>,
    state: AsyncAutoCompleteState
  ) => {
    const { getInputProps } = helpers;
    return (
      <div className={styles["input-container"]}>
        <i className={classNames(styles["icon-search"], "icon-search")} />
        <input
          type="text"
          {...getInputProps({
            onFocus: () => helpers.openMenu(),
            onBlur: () => helpers.closeMenu(),
            placeholder: intl.formatMessage("header.search.placeholder")
          })}
        />
        <SpinIcon hidden={!state.isLoading} />
      </div>
    );
  };

  const render = () => {
    return (
      <AsyncAutoComplete<GuestProfile>
        renderQueryInput={renderQueryInput}
        itemsProvider={(query) => spinnerService.getGuestProfilesByQuery(query)}
        keepQuery
        onChange={onItemSelect}
        className={classNames(styles.container)}
        GridItem={GuestDropdownItemGuestProfile}
      />
    );
  };
  return render();
};
